// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"styles_searchBox__3WSdA","searchInput":"styles_searchInput__2ETcT","btn":"styles_btn__14Lav","navImg":"styles_navImg__1eD-6"};